module.exports = __webpack_public_path__ + "img/bg.8c5e5046.png";